import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
// import AnalyticsActionFilter from '../analytics/AnalyticsActionFilter';
import PDPAnalyticsActionFilter from 'yoda-site-components/lib/analytics/PDPAnalyticsActionFilter';
import analyticsActions from 'yoda-site-components/lib/actionTypes/AnalyticsActionTypes';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';
import bundleProductPricingSelector, {
    bundleLotsPricingSelector,
} from '../selectors/Bundle/BundleProductPricingSelector';
import { selectedProductsForBundles } from '../selectors/Bundle/BundleProductOptionsSelector';

import {
    PDP_PAGE_LOAD_READY,
    PDP_CART_ADD_ANALYTICS,
    BUNDLE_PDP_CART_ADD_ANALYTICS,
    PDP_CART_UPDATE_ANALYTICS,
    PDP_TOOL_CLICK_ANALYTICS,
    PDP_SAMEDAY_PICKUP_ANALYTICS,
    PDP_CHECK_AVAILABILITY_ANALYTICS,
    PDP_OPEN_MODAL_ANALYTICS,
    PDP_CHANGE_ZIPCODE_ANALYTICS,
    PDP_VIDEO_PLAYER_ANALYTICS,
    PDP_PRODUCT_OOS_ANALYTICS,
    PDP_CARE_PLAN_VIEW_ANALYTICS,
    PDP_CARE_PLAN_ACCEPT_ANALYTICS,
    PDP_FORM_ERROR_ANALYTICS,
    SEARCH_STORES_CLICK_EVENT,
    SELECT_OPTIONS_ANALYTICS,
    PDP_ATC_CLICK_EVENT,
    PDP_SHOP_THE_LOOK_READY,
    PDP_SHOP_THIS_LOOK_CLICK_EVENT,
    PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT,
    PDP_SHOP_THE_COLLECTION_READY,
    PDP_ENABLE_VTO,
    PDP_ALL_SKU_SELECTED,
    PDP_PAGE_LOAD_PRODUCT_OOS,
} from '../actionTypes/AnalyticsActionTypes';

const analyticsActionFilter = new PDPAnalyticsActionFilter();

/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const AnalyticsMiddleware = store => next => action => { // eslint-disable-line
    /* istanbul ignore else */
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        let digitalDataInventory = null;
        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            /* istanbul ignore switch */
            switch (action.type) {
                case PDP_PAGE_LOAD_READY: {
                    digitalData = analyticsActionFilter.getPdpPageDL(
                        store,
                        action.payload,
                        bundleProductPricingSelector,
                        bundleLotsPricingSelector
                    );
                    digitalData = analyticsActionFilter.updateCommonDigitalData(digitalData);
                    analyticsEventName = 'digitalDataReady';
                    // triggering webvitals on page load success
                    logwebvitals(store, digitalData);
                    break;
                }
                case PDP_CART_ADD_ANALYTICS: {
                    digitalData = analyticsActionFilter.getCartAddData(store, action.payload);
                    /* istanbul ignore next */
                    analyticsEventName = 'cartAdd';
                    break;
                }
                case BUNDLE_PDP_CART_ADD_ANALYTICS: {
                    digitalData = analyticsActionFilter.getBundleCartAddData(
                        store,
                        action.payload,
                        selectedProductsForBundles
                    );
                    /* istanbul ignore next */
                    analyticsEventName = 'cartAdd';
                    break;
                }
                case PDP_CART_UPDATE_ANALYTICS: {
                    digitalData = analyticsActionFilter.getCartUpdateData(store, action.payload);
                    /* istanbul ignore next */
                    analyticsEventName = 'cartUpdate';
                    break;
                }

                case PDP_TOOL_CLICK_ANALYTICS: {
                    digitalData = analyticsActionFilter.getPdpToolName(action.payload);
                    analyticsEventName = 'pdpToolClick';
                    break;
                }

                case analyticsActions.PDP_KA_CLICK_ANALYTICS: {
                    digitalData = action.payload;
                    analyticsEventName = 'pdpKAClick';
                    break;
                }

                case PDP_SAMEDAY_PICKUP_ANALYTICS: {
                    digitalData = {};
                    analyticsEventName = 'sameDayPickup';
                    break;
                }

                case PDP_CHECK_AVAILABILITY_ANALYTICS: {
                    digitalData = analyticsActionFilter.getCheckAvailabilityData(store);
                    analyticsEventName = 'checkAvailability';
                    break;
                }

                case PDP_OPEN_MODAL_ANALYTICS: {
                    digitalData = analyticsActionFilter.getModalOpenData(action.payload);
                    analyticsEventName = 'openModal';
                    break;
                }

                case PDP_CHANGE_ZIPCODE_ANALYTICS: {
                    digitalData = {};
                    analyticsEventName = 'changeZipCode';
                    break;
                }

                case PDP_VIDEO_PLAYER_ANALYTICS: {
                    digitalData = analyticsActionFilter.getProductVideoData(action.payload);
                    analyticsEventName = 'videoLoaded';
                    break;
                }

                case PDP_PRODUCT_OOS_ANALYTICS: {
                    digitalData = analyticsActionFilter.getProductOOSData(store, {
                        sourceMiniPDP: false,
                    });
                    analyticsEventName = 'productOOS';
                    break;
                }

                case PDP_CARE_PLAN_VIEW_ANALYTICS: {
                    digitalData = analyticsActionFilter.getCarePlanViewData(action.payload);
                    analyticsEventName = 'carePlanView';
                    break;
                }

                case PDP_CARE_PLAN_ACCEPT_ANALYTICS: {
                    digitalData = analyticsActionFilter.getCarePlanAcceptData(action.payload);
                    analyticsEventName = 'carePlanAccept';
                    break;
                }

                case PDP_FORM_ERROR_ANALYTICS: {
                    digitalData = analyticsActionFilter.getFormErrorData(action.payload);
                    analyticsEventName = 'formError';
                    break;
                }

                case SEARCH_STORES_CLICK_EVENT: {
                    digitalData = analyticsActionFilter.getStoreSearchData(action.payload);
                    analyticsEventName = 'storeSearch';
                    break;
                }

                case SELECT_OPTIONS_ANALYTICS: {
                    digitalData = analyticsActionFilter.getSelectOptionsData();
                    analyticsEventName = 'selectOptionsPDP';
                    break;
                }

                case PDP_ATC_CLICK_EVENT: {
                    digitalData = action.clickStreamData;
                    analyticsEventName = 'triggerEnsightenError';
                    break;
                }

                case PDP_ALL_SKU_SELECTED: {
                    digitalData = analyticsActionFilter.getSelectSkuPDP(action.payload);
                    analyticsEventName = 'selectSkuPDP';
                    break;
                }

                case PDP_SHOP_THE_LOOK_READY: {
                    digitalData = analyticsActionFilter.getShopTheLookSuccess(action.payload);
                    analyticsEventName = 'digitalDataReady';
                    break;
                }

                case PDP_SHOP_THIS_LOOK_CLICK_EVENT: {
                    digitalData = analyticsActionFilter.getShopThisLookOnClick(action.payload);
                    analyticsEventName = 'shopTheLook';
                    break;
                }

                case PDP_SHOP_THE_LOOK_MINI_PDP_CLICK_EVENT: {
                    digitalData = analyticsActionFilter.getShopTheLookMiniPDPOnClick(
                        action.payload
                    );
                    analyticsEventName = 'shopTheLookDetail';
                    break;
                }

                case PDP_SHOP_THE_COLLECTION_READY: {
                    digitalData = analyticsActionFilter.getShopTheCollectionSuccess(action.payload);
                    analyticsEventName = 'digitalDataReady';
                    break;
                }

                case PDP_ENABLE_VTO: {
                    digitalData = {};
                    analyticsEventName = 'vto';
                    break;
                }
                case PDP_PAGE_LOAD_PRODUCT_OOS: {
                    digitalDataInventory = analyticsActionFilter.getPdpPageDLProductOOS(
                        store,
                        action.payload,
                        bundleProductPricingSelector,
                        bundleLotsPricingSelector
                    );
                    analyticsEventName = 'inventoryProductOOS';
                    break;
                }
                default:
                    break;
            }
            /* istanbul ignore next */
            if (analyticsEventName || digitalData || digitalDataInventory) {
                if (analyticsEventName === 'inventoryProductOOS') {
                    analytics.track(analyticsEventName, digitalDataInventory);
                } else {
                    analytics.track(analyticsEventName, digitalData);
                }
            }
        } catch (error) {
            // @TODO - this should be added into LOGGER
            console.error(`analytics: ${action.type} event is failed`, error);
        }
    }

    return next(action);
};

export default AnalyticsMiddleware;
